import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { deleteCameraPermissionMutation } from "../mutations";
import { accessManagementQuery } from "../queries";

/**
 * Hook to revoke all camera permissions from a user on a specific camera.
 * Automatically invalidates the access management query on success.
 *
 * @example
 * ```tsx
 * const { mutate, isPending } = useDeleteCameraPermission();
 *
 * const handleRevoke = () => {
 *   mutate({ user: userId, camera: cameraId });
 * };
 * ```
 */
export function useDeleteCameraPermission() {
  const apiConfig = useApiConfig();
  const queryClient = useQueryClient();

  const mutationApiConfig = {
    tenantId: apiConfig.tenant?.tenantId,
    apiBaseUrl: apiConfig.tenant?.apiBaseUrl,
    authenticatedFetch: apiConfig.authenticatedFetch,
  };

  return useMutation({
    ...deleteCameraPermissionMutation(mutationApiConfig, {}),
    onSuccess: () => {
      const queryKey = accessManagementQuery(apiConfig, {}).queryKey;
      void queryClient.invalidateQueries({ queryKey });
    },
  });
}
